import { Job } from 'generated/apolloComponents'
import React from 'react'

interface IProps {
  recommendations: Job[]
  header: string
  url: string
}
const Recommendations = ({ recommendations, header, url }: IProps) => (
  <div>
    <p>
      <strong>
        <a href={url}>{header}</a>
      </strong>
    </p>
    <ul>
      {recommendations &&
        recommendations.map((job, index) => {
          let label = ` - ${job.company.name}`
          label += `, ${job.city ? job.city : 'Remote'}`
          label += `${
            job.showSalary
              ? ` (${job.denominatedSalaryLong.money} ${job.denominatedSalaryLong.currency})`
              : ''
          }`
          return (
            <li key={index} className='list-outside'>
              <a
                href={`/companies/jobs/${job.id}?utm_source=rec`}
                rel='nofollow'
              >
                {job.position}
              </a>
              {label}
            </li>
          )
        })}
    </ul>
  </div>
)

export default Recommendations
